import React, { useEffect, useState } from 'react';
import '../styles/Header.css';
import logo from '../logo.svg';
import logoMark from '../logo-mark.svg';
import { useNavigate } from 'react-router-dom';
import { checkOnAuthStateChanged, getDocument, logout, mixpanelSetup, recordEvent } from '../functions';
import { DefaultUserImage, ExitScreen } from './';
import { Clock05Icon, Logout05Icon, HandPrayerIcon, Settings01Icon, UserCircleIcon } from 'hugeicons-react';
import { colour } from '../styles/GlobalStyles';
import { Wand } from '../assets/icons';

function Header(props) {
    const loggedIn = props.loggedIn;
    const showTimeline = props.showTimeline === undefined ? false : props.showTimeline;
    const navigate = useNavigate();
    const [openPanel, setOpenPanel] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [companyLogo, setCompanyLogo] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    useEffect(() => {

        const fetchCompanyInfo = async(companyId) => {
            const colRef = "companies";
            const queryData = await getDocument(colRef, companyId);
            if ( queryData.status === 200 ) {
                const companyData = queryData.data.data;
                setCompanyName(companyData.companyName);

                if ( companyData.logo !== null ) {
                    setCompanyLogo(companyData.logo);
                }
            }
        };

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                const adminIds = JSON.parse(process.env.REACT_APP_ADMINIDS);
                if (adminIds.includes(user.userId)) {
                    setIsAdmin(true);
                }

                const colRef = "users";
                const queryData = await getDocument(colRef, user.userId);
                if ( queryData.status === 200 ) {
                    const userData = queryData.data.data;
                    const email = userData.email;
                    const name = `${userData.firstName} ${userData.lastName}`;
                    await mixpanelSetup(email, name, user.userId);
                    if ( userData.companyId !== "" ) {
                        fetchCompanyInfo(userData.companyId);
                    }
                }
            }
        };
        
        fetchUserData();

        const handleWindowResize = () => {
			setInnerWidth(window.innerWidth);
		};
	  
		window.addEventListener('resize', handleWindowResize);
    }, []);

    const login = () => {
        navigate("/login");
    };

    const togglePanel = () => {
        setOpenPanel(!openPanel);
        recordEvent("toggle_header_panel", {});
    };

    const popoverBody = [
        {
            label: "Report history",
            icon: <Clock05Icon color={colour.gray06} size={14} />,
            cta: () => "/history",
            adminOnly: false
        },
        {
            label: "Settings",
            icon: <Settings01Icon color={colour.gray06} size={14} />,
            cta: () => "/settings",
            adminOnly: false
        },
        {
            label: "Profile",
            icon: <UserCircleIcon color={colour.gray06} size={14} />,
            cta: () => "/profile",
            adminOnly: false
        },
        {
            label: "God mode",
            icon: <HandPrayerIcon color={colour.gray06} size={14} />,
            cta: () => "/god-mode",
            adminOnly: true
        }
    ];

    const bookDemo = () => {
        recordEvent("book_demo", {});
        window.open("https://calendly.com/liam-maher/clozers-demo", "_blank");
    };

    const logoutFunc = async() => {
        await logout();
        navigate("/login");
        recordEvent("logout", {});
    };

    return (
        <React.Fragment>
            {
                openPanel === true &&
                <ExitScreen
                    clickScreen={() => setOpenPanel(false)}
                />
            }
            <div className={"header-outer-container " + (showTimeline === true ? "header-agentic-timeline" : "")}>
                <div className="header-inner-container">
                    <a href="/" className="">
                        <img
                            src={innerWidth < 1000 ? logoMark : logo}
                            className="header-logo cursor-pointer"
                            alt="Logo"
                            // onClick={() => goHome()}
                        />
                    </a>
                    {
                        loggedIn === false ?
                        <div 
                            className="text-button"
                            onClick={() => login()}
                        >
                            <span className="body-regular colour-primary">
                                Login
                            </span>
                        </div>
                        :
                        loggedIn !== null &&
                        <div className="header-auth-container relative-container">
                            <div 
                                className="text-button"
                                onClick={() => bookDemo()}
                            >
                                <span className="body-regular colour-primary">
                                    Book a demo
                                </span>
                            </div>
                            <DefaultUserImage
                                size="large"
                                clickFunc={() => loggedIn === true ? togglePanel() : login()}
                                image={companyLogo}
                            />
                            {
                                openPanel === true &&
                                <div className="header-popover-container popover">
                                    <div className="header-popover-element">
                                        <DefaultUserImage
                                            size="small"
                                            clickFunc={null}
                                            image={companyLogo}
                                        />
                                        <span className="body-semibold colour-primary">
                                            {companyName}
                                        </span>
                                    </div>
                                    <div className="header-popover-body-container">
                                        {
                                            popoverBody.map((item, index) =>
                                                isAdmin === false && item.adminOnly === true ?
                                                null
                                                :
                                                <a 
                                                    className="header-popover-body-element cursor-pointer no-underline"
                                                    key={index}
                                                    href={item.cta()}
                                                >
                                                    {item.icon}
                                                    <span className="body-regular colour-primary">
                                                        {item.label}
                                                    </span>
                                                </a>
                                            )
                                        }
                                    </div>
                                    <div className="header-popover-body-element">
                                        <a 
                                            className="header-popover-body-wand-container cursor-pointer no-underline"
                                            href="sms:+16592180908?body=Enter%20address%20here"
                                        >
                                            <Wand
                                                fill={colour.gray05}
                                                className="header-popover-body-wand"
                                            />
                                            <span className="body-regular colour-secondary">
                                                Text to ARV
                                            </span>
                                        </a>
                                        <span className="body-semibold colour-primary">
                                            +1 (659) 218-0908
                                        </span>
                                    </div>
                                    <div 
                                        className="header-popover-body-element cursor-pointer"
                                        onClick={() => logoutFunc()}
                                    >
                                        <Logout05Icon
                                            color={colour.gray05}
                                            size={14}
                                        />
                                        <span className="body-regular colour-secondary">
                                            Logout
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
};

export default Header;